<template>
  <section v-if="!window.PHP.bot && window.size.mobile" class="mt-3 mb-6 flex justify-center">
    <div class="w-full bg-zt-light/35 border border-zt-light flex flex-col items-center rounded-zt
                bg-[url(/wp-content/themes/zawodtyper/assets/images/info_sporty_walki.svg)] bg-no-repeat bg-right">
      <span class="font-semibold mt-[9px] mb-2.5">Sporty walki na Zawód Typer</span>
      <div class="relative flex flex-col items-center gap-1 text-xs mb-4">
        <div>
          <span class="text-zt-red font-semibold">Relacje</span>
          <span class="ml-1">tekstowe</span>
        </div>
        <div>
          <span class="text-zt-red font-semibold">Wyniki</span>
          <span class="ml-1">walk</span>
          <span class="font-semibold ml-1">na żywo</span>
        </div>
        <div>
          <span class="text-zt-red font-semibold">Ostatnie walki</span>
          <span class="ml-1">zawodników</span>
        </div>
        <div>
          <span class="text-zt-red font-semibold">Terminarz</span>
          <span class="ml-1">najbliższych gal</span>
        </div>
      </div>
      <a href="/sporty-walk/" @click="handleCount()"
         class="no-default-style px-3 py-2 text-xs font-semibold border border-zt-red rounded-zt text-zt-red zt-hover
                mb-3 z-10">
        SPRAWDŻ SPORTY WALKI
      </a>
    </div>
  </section>
</template>

<script>
import { countClicks } from '../../../assets/js/utils';

export default {
  name: 'MartialArtsInfo',
  methods: {
    handleCount() {
      countClicks('Informacyjka box niewidzialny sporty walki');
    }
  }
};
</script>
